module.exports = __webpack_public_path__ + "img/KinokoTable52.87b71a44.jpg";